import ReactDOM from 'react-dom/client';
import App from './App';
import { handleHbaCallback } from './utils/hbaCallback';
import { installIoniconsFetchFailureGuard } from './utils/ioniconsFetchGuard';

// Extract SSO loginToken from URL before React mounts
// This prevents race conditions with HashRouter (C1) and Referer leakage (C2)
const urlParams = new URLSearchParams(window.location.search);
const loginToken = urlParams.get('loginToken');
const ssoError = urlParams.get('error');
const ssoNonce = urlParams.get('sso_nonce');

if (loginToken || ssoError) {
  window.__pendingSSOToken = loginToken;
  window.__pendingSSOError = ssoError;
  window.__pendingSSONonce = ssoNonce;
  // Strip ALL SSO params from URL immediately (prevents Referer leakage)
  window.history.replaceState({}, '', window.location.pathname + window.location.hash);
}

// Detect HBA authenticator callback. When the URL is a callback target, the
// helper publishes the code via BroadcastChannel, scrubs the URL, replaces
// the body with a minimal "complete" view, schedules window.close(), and
// returns true — at which point we skip the React mount entirely.
if (!handleHbaCallback()) {
  installIoniconsFetchFailureGuard();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
}
